import React, { useState, useEffect } from 'react';
import {
  View,
  TouchableOpacity,
  StyleSheet,
  Dimensions,
  TouchableWithoutFeedback,
} from 'react-native';
import Svg, { Path } from 'react-native-svg';
import Modal from 'modal-react-native-web';
import CustomText from '../customText/CustomText';
import theme from '../../constants/theme.style.js';
import ProfileAvatarBackground from '../profileAvatar/ProfileAvatarBackground';

const styles = StyleSheet.create({
  container: {
    height: 70,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    right: 30,
    flexDirection: 'row',
  },
  modalBackgroundView: {
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  tab: {
    flexDirection: 'row',
  },
  profileNameContainer: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  downButton: {
    width: 35,
    height: 35,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ffffff50',
    borderRadius: 15,
  },
  modalView: {
    width: 180,
    minHeight: 150,
    position: 'absolute',
    top: 70,
    right: 20,
    justifyContent: 'center',
    backgroundColor: theme.WHITE_COLOR,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.25,
    shadowRadius: 5.84,
    elevation: 5,
  },
  dropDownButton: {
    width: '80%',
    borderBottomWidth: 1,
    borderBottomColor: theme.GREY_LIGHTER_COLOR,
  },
  dropDownButtonNoLine: {
    borderBottomWidth: 0,
  },
  dropDownText: {
    color: theme.GREY_DARKER_COLOR,
    padding: 15,
    fontSize: theme.FONT_SIZE_HEADLINE,
  },
  logoutText: {
    color: theme.GREY_DARKER_COLOR,
    padding: 15,
    fontWeight: 'bold',
    fontSize: theme.FONT_SIZE_HEADLINE,
  },
  avatarContainer: {
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 50,
    marginRight: 10,
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: 15,
  },
});

const DropDown = ({ nav, currentUser, onLogout, onResetAll }) => {
  const dimensions = Dimensions.get('window');
  const [modalVisible, setModalVisible] = useState(false);

  const profileActive = nav.state.routes[4].index === 0 && nav.state.index === 4;
  const tintColor = profileActive ? '#CBE54E' : theme.GREY_LIGHT_COLOR;

  useEffect(() => {
    Modal.setAppElement('body');
    // showRefPosition();
  });

  function logoutUser() {
    onLogout()
      .then(() => nav.navigate('Auth'))
      .then(() => onResetAll());
  }

  const userName = currentUser.user ? currentUser.user.nickname : 'Profile';

  const profileImage = (
    <ProfileAvatarBackground avatar={currentUser?.user?.avatar} style={styles.avatar} />
  );

  const home = (
    <TouchableOpacity
      style={styles.dropDownButton}
      onPress={() => {
        if (nav.state.index !== 0) {
          nav.navigate('Home');
        }
        setModalVisible(!modalVisible);
      }}
    >
      <View style={styles.dropDownItem}>
        <CustomText style={styles.dropDownText}>Home</CustomText>
      </View>
    </TouchableOpacity>
  );

  const inbox = (
    <TouchableOpacity
      style={styles.dropDownButton}
      onPress={() => {
        if (nav.state.index !== 1) {
          nav.navigate('Inbox');
        }
        setModalVisible(!modalVisible);
      }}
    >
      <View style={styles.dropDownItem}>
        <CustomText style={styles.dropDownText}>Inbox</CustomText>
      </View>
    </TouchableOpacity>
  );

  const newMessage = (
    <TouchableOpacity
      style={styles.dropDownButton}
      onPress={() => {
        if (nav.state.index !== 2) {
          nav.navigate('NewMessageFriendsSelectionMobileWeb');
        }
        setModalVisible(!modalVisible);
      }}
    >
      <View style={styles.dropDownItem}>
        <CustomText style={styles.dropDownText}>New Turtlet</CustomText>
      </View>
    </TouchableOpacity>
  );

  const friends = (
    <TouchableOpacity
      style={styles.dropDownButton}
      onPress={() => {
        if (nav.state.index !== 3) {
          nav.navigate('Friends');
        }
        setModalVisible(!modalVisible);
      }}
    >
      <View style={styles.dropDownItem}>
        <CustomText style={styles.dropDownText}>Friends</CustomText>
      </View>
    </TouchableOpacity>
  );
  return (
    <View style={styles.container}>
      <View
        style={[
          {
            cursor: 'pointer',
            marginRight: 20,
          },
        ]}
      >
        <TouchableWithoutFeedback
          onPress={() => {
            if (!profileActive) {
              nav.navigate('Profile');
            }
          }}
        >
          <View style={styles.tab}>
            <View style={styles.avatarContainer} testID="avatarView">
              {profileImage}
            </View>
            <View style={styles.profileNameContainer}>
              <CustomText
                testID="profileName"
                numberOfLines={1}
                maxFontSizeMultiplier={1}
                style={{
                  fontSize: 16,
                  color: `${tintColor}`,
                  textAlign: 'left',
                  fontWeight: 'bold',
                  minWidth: 40,
                  overflow: 'hidden',
                }}
              >
                {userName}
              </CustomText>
            </View>
          </View>
        </TouchableWithoutFeedback>
      </View>
      <TouchableWithoutFeedback
        onPress={() => {
          setModalVisible(!modalVisible);
        }}
      >
        <View
          testID="dropDownButton"
          style={[
            styles.downButton,
            { cursor: 'pointer', backgroundColor: modalVisible ? '#fff' : '#ffffff30' },
          ]}
        >
          <Svg
            fill="none"
            viewBox="0 0 24 24"
            height="24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <Path
              xmlns="http://www.w3.org/2000/svg"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.29289 9.29289C5.68342 8.90237 6.31658 8.90237 6.70711 9.29289L12 14.5858L17.2929 9.29289C17.6834 8.90237 18.3166 8.90237 18.7071 9.29289C19.0976 9.68342 19.0976 10.3166 18.7071 10.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L5.29289 10.7071C4.90237 10.3166 4.90237 9.68342 5.29289 9.29289Z"
              fill={modalVisible ? theme.GREEN_DARKER_COLOR : '#fff'}
            />
          </Svg>
        </View>
      </TouchableWithoutFeedback>
      <Modal animationType="none" transparent visible={modalVisible}>
        <TouchableOpacity
          style={styles.modalBackgroundView}
          activeOpacity={1}
          onPress={() => {
            setModalVisible(false);
          }}
        >
          <View style={styles.modalBackgroundView}>
            <View style={styles.modalView}>
              {dimensions.width < 800 && home}
              {dimensions.width < 800 && inbox}
              {dimensions.width < 800 && newMessage}
              {dimensions.width < 800 && friends}
              <TouchableOpacity
                style={styles.dropDownButton}
                onPress={() => {
                  if (!profileActive) {
                    nav.navigate('Profile');
                  }
                  setModalVisible(!modalVisible);
                }}
              >
                <View style={styles.dropDownItem}>
                  <CustomText style={styles.dropDownText}>Profile</CustomText>
                </View>
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.dropDownButton}
                onPress={() => {
                  if (nav.state.routes[4].index !== 1) {
                    nav.navigate('Settings');
                  }
                  setModalVisible(!modalVisible);
                }}
              >
                <View style={styles.dropDownItem}>
                  <CustomText style={styles.dropDownText}>Settings</CustomText>
                </View>
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.dropDownButton}
                onPress={() => {
                  if (nav.state.routes[4].index !== 2) {
                    nav.navigate('ContactScreen');
                  }
                  setModalVisible(!modalVisible);
                }}
              >
                <View style={styles.dropDownItem}>
                  <CustomText style={styles.dropDownText}>Contact Us</CustomText>
                </View>
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.dropDownButton}
                onPress={() => {
                  if (nav.state.routes[4].index !== 3) {
                    nav.navigate('Data');
                  }
                  setModalVisible(!modalVisible);
                }}
              >
                <View style={styles.dropDownItem}>
                  <CustomText style={styles.dropDownText}>Terms</CustomText>
                </View>
              </TouchableOpacity>
              <TouchableOpacity
                style={[styles.dropDownButton, styles.dropDownButtonNoLine]}
                testID="logoutButton"
                onPress={() => {
                  logoutUser();
                  setModalVisible(!modalVisible);
                }}
              >
                <View style={styles.dropDownItem}>
                  <CustomText style={styles.logoutText}>Logout</CustomText>
                </View>
              </TouchableOpacity>
            </View>
          </View>
        </TouchableOpacity>
      </Modal>
    </View>
  );
};

export default DropDown;
